export const getGACookieId = () => {
  let gaCookieValue = '';
  const cookieArray = document.cookie.split(' ');
  cookieArray.forEach((cookie) => {
    const splitCookie = cookie.split('=');
    if (splitCookie[0] === '_ga') {
      const gaCookie = splitCookie[1];
      gaCookieValue = gaCookie.slice(6, gaCookie.length - 1);
    }
  });

  return gaCookieValue;
};
